
import React from 'react';
import { Check } from 'lucide-react';

const AdultBeginnerJourney = () => {
  const journeySteps = [
    {
      title: "Grundlæggende færdigheder",
      description: "Opbygge et solidt fundament af musikalske færdigheder med tilgange designet til voksne.",
      points: [
        "Ergonomisk korrekt siddestilling og håndposition",
        "Effektiv nodelæsning med voksenfokuserede metoder",
        "Grundlæggende teknikker og fingerøvelser",
        "Hurtig introduktion til akkorder og musikteori"
      ]
    },
    {
      title: "Praktisk musikforståelse",
      description: "Udvikle praktiske færdigheder, der hurtigt kan anvendes i musikalske sammenhænge.",
      points: [
        "Lære at spille enkle versioner af kendte sange",
        "Akkompagnementsmønstre til populære musikgenrer",
        "Forståelse af musikalske strukturer og harmonier",
        "Effektive øveteknikker tilpasset travle tidsplaner"
      ]
    },
    {
      title: "Personlig musikalsk udvikling",
      description: "Forfølge dine individuelle musikalske mål og interesser.",
      points: [
        "Skræddersyet repertoire baseret på dine musikalske præferencer",
        "Teknisk udvikling for at håndtere mere udfordrende stykker",
        "Mulighed for at udforske improvisation og komposition",
        "Gradvis opbygning af selvtillid og musikalsk udtryk"
      ]
    }
  ];

  return (
    <section className="py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-serif font-bold mb-4">
              Din rejse som voksen klaverbegynder
            </h2>
            <p className="text-lg text-gray-600">
              Min tilgang til voksne begyndere fokuserer på hurtig progression og praktiske færdigheder, 
              så du hurtigt kan spille musik, du nyder, samtidig med at du opbygger et solidt teknisk fundament.
            </p>
          </div>
          
          <div className="space-y-12">
            {journeySteps.map((step, index) => (
              <div key={index} className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
                <div className="flex items-center mb-4">
                  <div className="w-10 h-10 rounded-full bg-piano-gold flex items-center justify-center text-white font-bold mr-4">
                    {index + 1}
                  </div>
                  <h3 className="text-xl font-serif font-semibold">{step.title}</h3>
                </div>
                <p className="text-gray-600 mb-4">{step.description}</p>
                <ul className="space-y-2">
                  {step.points.map((point, i) => (
                    <li key={i} className="flex items-start">
                      <Check className="w-5 h-5 text-piano-gold mr-2 mt-0.5 flex-shrink-0" />
                      <span className="text-gray-700">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          
          <div className="mt-12 bg-gray-50 p-6 rounded-lg border border-gray-200">
            <h3 className="text-xl font-serif font-semibold mb-4 text-center">Hvor lang tid tager det at lære klaver som voksen?</h3>
            <p className="text-gray-600">
              Som voksen begynder vil du typisk se hurtigere fremskridt i starten end børn gør, takket være din evne til at forstå koncepter og din målrettede tilgang til øvning. 
              Med regelmæssig øvning kan du forvente at spille enkle stykker efter bare 2-3 måneder, og inden for 6-12 måneder kan du have opbygget et pænt repertoire af stykker. 
              Husk, at det vigtigste er at nyde processen og finde glæde i musikken undervejs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdultBeginnerJourney;
